const preProdApiBaseUrl = "https://api.preprod.dev.uk.jylo.ai";
const isPreProd = window.location.hostname === "word-addin-preprod.dev.uk.jylo.ai";
const localInferenceBaseUrl = "http://localhost:8086/";
const localPlaybookBaseUrl = "http://localhost:8081";
const localProjectsBaseUrl = "http://localhost:8085";
const isLocal = window.location.hostname === "localhost";

// Dynamic API base URL (will be set from Auth0 org metadata)
let dynamicApiBaseUrl: string | null = null;

export const setApiBaseUrl = (url: string) => {
  dynamicApiBaseUrl = url;
};

export const getApiBaseUrl = (): string => {
  if (!dynamicApiBaseUrl) {
    throw new Error("API base URL not configured.");
  }
  return dynamicApiBaseUrl;
};

export const getInferenceBaseUrl = (): string => {
  if (isLocal) return localInferenceBaseUrl;
  if (isPreProd) return preProdApiBaseUrl;
  return getApiBaseUrl();
};

export const getPlaybookBaseUrl = (): string => {
  if (isLocal) return localPlaybookBaseUrl;
  if (isPreProd) return preProdApiBaseUrl;
  return getApiBaseUrl();
};

// Base URL for the Projects API (Flow-sourced assemblies). In pre-prod and
// production the same gateway host serves both APIs, differentiated by the
// /projects vs /playbooks route prefix; only local dev uses a separate port.
export const getProjectsBaseUrl = (): string => {
  if (isLocal) return localProjectsBaseUrl;
  if (isPreProd) return preProdApiBaseUrl;
  return getApiBaseUrl();
};
